"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M9.5 4c-.13 0-.24.05-.33.13l-4 3.5c-.1.09-.17.22-.17.37s.07.28.17.37l4 3.5a.495.495 0 00.83-.37v-7c0-.28-.22-.5-.5-.5z"];
//# sourceMappingURL=caret-left.js.map